<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div>
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mt-6">
          <label class="label-input">Product Facts</label>
          <ckeditor :editor="editor" v-model="fields.productFacts" :config="editorConfig" />
        </div>

        <div class="mt-6">
          <label class="label-input">Direction For Use</label>
          <ckeditor :editor="editor" v-model="fields.directionForUse" :config="editorConfig" />
        </div>

        <div class="mt-6 freestyle-info-table">
          <label class="label-input">Table</label>
          <ckeditor :editor="editor" v-model="fields.table" :config="editorConfig" />
        </div>

        <div class="mt-6">
          <label class="label-input">Items</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <UploadImage
                  @callback="obj => handleUploadImage(obj, 'url1')"
                  :image="{ imageSrc: fields.image.url1 }"
                  :height="`150`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveImage('url1')"
                />
              </v-col>
              <v-col cols="12" md="6">
                <UploadImage
                  @callback="obj => handleUploadImage(obj, 'url2')"
                  :image="{ imageSrc: fields.image.url2 }"
                  :height="`150`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveImage('url2')"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <div>
              <div class="font-weight-medium">Spacing</div>
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-model="fields.topPadding" label="Top Padding" dense hide-details />
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="fields.bottomPadding" label="Bottom Padding" dense hide-details />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3 mb-2">Container Colors</div>
              <v-row>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields.colors.backgroundColor"
                    name="backgroundColor"
                    label="Background Color"
                    default-color="#ffffff"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields.colors.textColor"
                    name="textColor"
                    label="Text Color"
                    default-color="#000000"
                  />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3 mb-2">Table Colors</div>
              <v-row>
                <v-col md="3" cols="12">
                  <ColorPicker
                    v-model="fields.colors.tableHeaderBackgroundColor"
                    name="tableHeaderBackgroundColor"
                    label="Table Header Background Color"
                    default-color="#14a16c"
                  />
                </v-col>
                <v-col md="3" cols="12">
                  <ColorPicker
                    v-model="fields.colors.tableHeaderTextColor"
                    name="tableHeaderTextColor"
                    label="Table Header Text Color"
                    default-color="#ffffff"
                  />
                </v-col>
                <v-col md="3" cols="12">
                  <ColorPicker
                    v-model="fields.colors.tableOldRowBackgroundColor"
                    name="tableOldRowBackgroundColor"
                    label="Table Old Row Background Color"
                    default-color="#d6dad9"
                  />
                </v-col>
                <v-col md="3" cols="12">
                  <ColorPicker
                    v-model="fields.colors.tableOldRowTextColor"
                    name="tableOldRowTextColor"
                    label="Table Old Row Text Color"
                    default-color="#000000"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import ColorPicker from './common/color-picker.vue';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

export default {
  name: 'freestyle-info-section-editor',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Freestyle Info Section',
        enableAnchor: false,
        colors: {
          backgroundColor: '#ffffff',
          textColor: '#000000',
          tableHeaderBackgroundColor: '#14a16c',
          tableHeaderTextColor: '#ffffff',
          tableOldRowBackgroundColor: '#d6dad9',
          tableOldRowTextColor: '#000000',
        },
        productFacts: '',
        directionForUse: '',
        table: '',
        image: {
          url1: '',
          url2: '',
          enable: true,
        },
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    if (this.sectionEditor.sectionExtract) {
      this.fields = {
        ...this.fields,
        ...this.sectionEditor.sectionExtract,
      };
    }
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal.sectionExtract) {
          this.fields = {
            ...this.fields,
            ...newVal.sectionExtract,
          };
        }
      },
      deep: true,
    },
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFreestyleInfo(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj, key) {
      this.fields.image[key] = obj.imageSrc;
    },
    handleRemoveImage(key) {
      this.fields.image[key] = '';
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable {
  min-height: 100px;
}
.thumbnail-text {
  flex: 1;
  p {
    margin: 0 !important;
  }
}
.item-thumbnail {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

::v-deep .freestyle-info-table table * > p {
  margin: 0 !important;
}
</style>
